module.exports = __webpack_public_path__ + "img/IMG_8929.d0a6304c.jpg";